import React from "react";

import "./Footer.css";

export default function Footer() {
  return (
    <footer className="admin-footer">
      <span>&copy; {new Date().getFullYear()} Tecniqa. All Rights Reserved.</span>
      <span className="admin-footer-meta">Admin Console</span>
    </footer>
  );
}
